import React, { useEffect, useState } from "react";
import './App.css';
import './assets/style.css';
import './assets/plugins.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import apiToken from './apiToken';
import UserSignup from './components/Login/UserSignup';
import ForgotPassword from './components/Login/ForgotPassword';
import ResetPassword from './components/Login/ResetPassword';
import PaymentSuccess from './components/User/PaymentSuccess';
import Quiz from './components/Quiz/Quiz';
import UserAssessmentResult from './components/Report/UserAssessmentResult';
import PackageReport from './components/Report/PackageReport';
import AssessmentList from './components/UserAssessments/AssessmentList';
import Assessment from './components/UserAssessments/Assessment';
import AssesementPackages from "./components/Expert/Packages/AssesmentPackages";
import Header from "./components/User/Header";
import Footer from "./components/User/Footer";
import PackageList from './components/User/PackageList';
import User from "./components/Expert/User/ExpertUser";
import TicketsInfo from "./components/User/Support/TicketsInfo";
import UserSupport from "./components/User/Support/Usersupport";
import AssignPackage from "./components/Expert/User/AssignPackage";
import UserView from "./components/Expert/User/UserView";
import AddUser from "./components/Expert/User/AdduserModal";
import ExpertOverview from "./components/Expert/Overview/ExpertOverview";
import ExpertSignup from "./components/Login/ExpertSignup";
import Purchase from "./components/Expert/PackagePurchase/Purchase";
import ProfileOverview from "./components/Profile/ProfileOverview";
import EditProfile from "./components/Profile/EditProfile";
import ExpertPaymentSuccess from "./components/Expert/PackagePurchase/ExpertPaymentSuccess";
import ProfileChangePassword from "./components/Profile/ProfileChangePassword";
import RemoveLicenses from "./components/Expert/PackagePurchase/RemoveLicenses";
import Faqs from "./components/Faqs/Faqs";
import OAuth2RedirectHandler from "./components/User/Oauth2/OAuth2RedirectHandler";
import ExpertOnboarding from "./components/Login/ExpertOnboarding";
import ExternalRedirect from './components/ExternalRedirect';
import NotFound from './components/NotFound';
import LoginError from "./components/Login/LoginError";
import UserPackage from "./components/User/UserPackage";
import TrainingModule from "./components/Training/TrainingModule";
import GuidanceArticle from "./components/Guidance/GuidanceArticle";
import Home from "./components/Static/Home";
import AccountRequired from "./components/Login/AccountRequired";
import About from "./components/Static/About";
import Howitworks from "./components/Static/Howitworks";
import StaticPackages from "./components/Static/Packages";
import StaticThemes from "./components/Static/Themes";
import Distinctiveness from "./components/Static/Distinctiveness";
import Team from "./components/Static/Team";
import ContactUs from "./components/Static/ContactUs";
import { jwtDecode } from 'jwt-decode';
import { TRAINING_MODULES_ENABLED } from './featureFlags';

/**
 * Reads the stored session and decides which route tree the app mounts.
 *
 * This has to happen BEFORE the first render, not in an effect afterwards.
 * The four route trees below are mutually exclusive and every one of them
 * redirects unknown paths somewhere, so mounting the wrong one for even a
 * single frame is destructive: the signed-out tree's catch-all replaces the
 * URL with /login, the signed-in tree then sends /login on to /overview, and
 * the path the person actually asked for is gone before auth ever resolves.
 * That is why a cold load of an emailed or PDF link to /packages/report,
 * /assessments or /training/:articleSlug used to land on /overview while
 * in-app navigation to the same paths worked.
 *
 * Every read is wrapped. localStorage throws in Safari private browsing and
 * wherever site data is blocked, and jwtDecode throws on a truncated token -
 * a session that cannot be read is simply not a session. It is never a reason
 * to leave auth unresolved, because an unresolved gate renders nothing at all.
 */
function readAuthState() {
  try {
    const tokenString = localStorage.getItem('token');
    const stored = tokenString ? JSON.parse(tokenString) : null;
    const jwt = localStorage.getItem('jwt');
    if (stored && stored.token && jwt) {
      const payload = jwtDecode(jwt);
      const expiresAt = Number(payload && payload.exp) * 1000;
      // A token with no usable exp counts as expired rather than as valid:
      // the old check compared NaN and fell through to "signed in".
      if (expiresAt > Date.now()) {
        return {
          resolved: true,
          loginStatus: 'Y',
          userStatus: localStorage.getItem('userStatus'),
        };
      }
    }
  } catch (e) {
    console.warn('auth: stored session could not be read, treating as signed out', e);
  }
  return { resolved: true, loginStatus: 'N', userStatus: null };
}

function App() {
  const { setToken } = apiToken();
  // Resolved synchronously on the first render - see readAuthState.
  const [auth, setAuth] = useState(readAuthState);
  const userLoginStatus = auth.loginStatus;
  const userStatus = auth.userStatus;
  const packageId = localStorage.getItem('selectedPackageId');
  const staticScreen = localStorage.getItem("staticScreen");

  // Login and the OAuth handler call this once they have written the session,
  // so the tree swaps without a reload.
  const getStatus = (status) => {
    setAuth({
      resolved: true,
      loginStatus: status,
      userStatus: localStorage.getItem("userStatus"),
    });
  }

  // The gate. No route tree renders while auth is unresolved, because any tree
  // rendered too early rewrites the URL and loses the requested path. Today
  // readAuthState always resolves on the first render, so this never paints;
  // it is what keeps the guarantee if resolving a session ever needs a round
  // trip to the API.
  if (!auth.resolved) {
    return <div className="" />;
  }

  return (
    <div className="">
      {userLoginStatus === 'Y' ?
        <>
          {userStatus === 'N' ? <>
            <BrowserRouter>
              <Routes>
                <Route path="/login-error" element={<LoginError />} />
                <Route path="/onboarding" element={<Navigate to='/login-error' />} />
                <Route path="*" element={<Navigate to='/login-error' />} />
              </Routes>
            </BrowserRouter>
          </> :
            userStatus === 'A' ? <>
            {staticScreen == 'Y' ?
             <BrowserRouter>
               <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/howitworks" element={<Howitworks />} />
            <Route path="/themes" element={<StaticThemes />} />
            <Route path="/theme/packages" element={<StaticPackages />} />
            <Route path="/distinctiveness" element={<Distinctiveness />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="*" element={<Navigate to='/' />} />
            </Routes>
            </BrowserRouter>
             :
            <BrowserRouter>
                <div className="d-flex flex-column flex-root app-root" id="kt_app_root">
                  <div className="app-page  flex-column flex-column-fluid " id="kt_app_page">
                    <Header />
                    <div className="app-container  container-fluid  container-xxl app-container-body" id="kt_app_header_container">
                      <Routes>
                        <Route path="/" element={<Navigate to='/overview' />} />
                        <Route path="/account-required" element={<Navigate to='/package/summary' />} />
                        <Route path="/oauth2/redirect/:token" element={<OAuth2RedirectHandler token={setToken} status={getStatus} />} />
                        <Route path="/login" element={<Navigate to='/overview' />} />
                        <Route path="/packages" element={<PackageList />} />
                        <Route path="/package/summary" element={packageId ? <UserPackage /> : <ExpertOverview />} />
                        <Route path="/payment/:packageId/:couponId/success" element={<PaymentSuccess />} />
                        <Route path="/payment/:packageId/:couponId/success/:licenses" element={<ExpertPaymentSuccess />} />
                        <Route path="/overview" element={packageId ? <Navigate to='/package/summary' /> : <ExpertOverview />} />
                        <Route path="/assessments/:seoName/quiz" element={<Quiz />} />
                        <Route path="/assessments/:seoName/results" element={<UserAssessmentResult />} />
                        <Route path="/packages/report" element={<PackageReport />} />
                        <Route path="/packages/:packageId/report" element={<PackageReport />} />
                        {/* Hidden until a module is published - see featureFlags.js. */}
                        <Route path="/training/:articleSlug" element={TRAINING_MODULES_ENABLED ? <TrainingModule /> : <Navigate to='/overview' replace />} />
                        <Route path="/guidance/:articleSlug" element={<GuidanceArticle />} />
                        <Route path="/assessments" element={<AssessmentList />} />
                        <Route path="/assessments/:assessmentId/:seoName" element={<Assessment />} />
                        <Route path="/expert/packages" element={<AssesementPackages />} />
                        <Route path="/expert/users" element={<User />} />
                        <Route path="/support" element={<UserSupport />} />
                        <Route path="/support/view/:id" element={<TicketsInfo />} />
                        <Route path="/expert/users/assign/:id" element={<AssignPackage />} />
                        {/* Old address that carried the client's name; kept so existing links still open. */}
                        <Route path="/expert/users/:name/:id" element={<AssignPackage />} />
                        <Route path="/expert/users/view/:id" element={<UserView />} />
                        <Route path="/expert/users/add" element={<AddUser />} />
                        <Route path="/expert/users/edit/:id" element={<AddUser edit={true} />} />
                        <Route path="/purchase/:id" element={<Purchase />} />
                        <Route path="/profile" element={<ProfileOverview />} />
                        <Route path="/editProfile" element={<EditProfile />} />
                        <Route path="/changePassword" element={<ProfileChangePassword />} />
                        <Route path="/packages/purchase/:id" element={<Purchase />} />
                        <Route path="/packages/remove/:id" element={<RemoveLicenses />} />
                        <Route path="/faqs" element={<Faqs />} />
                        <Route path="/onboarding" element={<Navigate to='/overview' />} />
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                    </div>
                  </div>
                </div>
                <Footer />
                </BrowserRouter>
                }
            </> : <>
              <BrowserRouter>
                <Routes>
                  <Route path="/onboarding" element={<ExpertOnboarding />} />
                  <Route path="/oauth2/redirect/:token" element={<Navigate to='/onboarding' />} />
                  <Route path="/login-error" element={<LoginError />} />
                  <Route path="/login" element={<Navigate to='/onboarding' />} />
                  <Route path="/packages" element={<Navigate to='/onboarding' />} />
                  <Route path="/payment/:packageId/:couponId/success" element={<Navigate to='/onboarding' />} />
                  <Route path="/payment/:packageId/:couponId/success/:licenses" element={<Navigate to='/onboarding' />} />
                  <Route path="/overview" element={<Navigate to='/onboarding' />} />
                  <Route path="/assessments/:seoName/quiz" element={<Navigate to='/onboarding' />} />
                  <Route path="/assessments/:seoName/results" element={<Navigate to='/onboarding' />} />
                  <Route path="/packages/report" element={<Navigate to='/onboarding' />} />
                  <Route path="/packages/:packageId/report" element={<Navigate to='/onboarding' />} />
                  <Route path="/training/:articleSlug" element={<Navigate to='/onboarding' />} />
                  <Route path="/guidance/:articleSlug" element={<Navigate to='/onboarding' />} />
                  <Route path="/assessments" element={<Navigate to='/onboarding' />} />
                  <Route path="/assessments/:assessmentId/:seoName" element={<Navigate to='/onboarding' />} />
                  <Route path="/expert/packages" element={<Navigate to='/onboarding' />} />
                  <Route path="/expert/users" element={<Navigate to='/onboarding' />} />
                  <Route path="/support" element={<Navigate to='/onboarding' />} />
                  <Route path="/support/view/:id" element={<Navigate to='/onboarding' />} />
                  <Route path="/expert/users/assign/:id" element={<Navigate to='/onboarding' />} />
                  {/* Old address that carried the client's name; kept so existing links still open. */}
                  <Route path="/expert/users/:name/:id" element={<Navigate to='/onboarding' />} />
                  <Route path="/expert/users/view/:id" element={<Navigate to='/onboarding' />} />
                  <Route path="/expert/users/add" element={<Navigate to='/onboarding' />} />
                  <Route path="/expert/users/edit/:id" element={<Navigate to='/onboarding' />} />
                  <Route path="/purchase/:id" element={<Navigate to='/onboarding' />} />
                  <Route path="/profile" element={<Navigate to='/onboarding' />} />
                  <Route path="/editProfile" element={<Navigate to='/onboarding' />} />
                  <Route path="/changePassword" element={<Navigate to='/onboarding' />} />
                  <Route path="/packages/purchase/:id" element={<Navigate to='/onboarding' />} />
                  <Route path="/packages/remove/:id" element={<Navigate to='/onboarding' />} />
                  <Route path="/faqs" element={<Navigate to='/onboarding' />} />
                  <Route path="*" element={<Navigate to='/onboarding' />} />
                </Routes>
              </BrowserRouter>
            </>
          }

        </>
        :
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to='/login' />} />
            <Route path="/about" element={<ExternalRedirect to='https://www.vertivio.com/about/' />} />
            <Route path="/howitworks" element={<ExternalRedirect to='https://www.vertivio.com/#platform' />} />
            <Route path="/themes" element={<ExternalRedirect to='https://www.vertivio.com/#solutions' />} />
            <Route path="/theme/packages" element={<Navigate to='/login' />} />
            <Route path="/distinctiveness" element={<ExternalRedirect to='https://www.vertivio.com/#products' />} />
            <Route path="/team" element={<ExternalRedirect to='https://www.vertivio.com/about/' />} />
            <Route path="/contactus" element={<ExternalRedirect to='https://www.vertivio.com/contact/' />} />
            <Route path="/account-required" element={<AccountRequired />} />
            <Route path="/login" element={<Login token={setToken} status={getStatus} />} />
            <Route path="/signup" element={<UserSignup />} />
            <Route path="/expert-signup" element={<ExpertSignup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/login-error" element={<LoginError />} />
            <Route path="/oauth2/redirect/" element={<Navigate to='/login-error' />} />
            <Route path="/oauth2/redirect/:token" element={<OAuth2RedirectHandler token={setToken} status={getStatus} />} />
            {userLoginStatus === 'N' ?
              <>
                <Route path="/overview" element={<Navigate to='/login' />} />
                <Route path="/packages" element={<Navigate to='/login' />} />
                <Route path="/payment/:packageId/:couponId/success" element={<Navigate to='/login' />} />
                <Route path="/payment/:packageId/:couponId/success/:licenses" element={<Navigate to='/login' />} />
                <Route path="/expert" element={<Navigate to='/login' />} />
                <Route path="/assessments/:seoName/quiz" element={<Navigate to='/login' />} />
                <Route path="/assessments/:seoName/results" element={<Navigate to='/login' />} />
                <Route path="/packages/report" element={<Navigate to='/login' />} />
                <Route path="/packages/:packageId/report" element={<Navigate to='/login' />} />
                <Route path="/training/:articleSlug" element={<Navigate to='/login' />} />
                <Route path="/guidance/:articleSlug" element={<Navigate to='/login' />} />
                <Route path="/assessments" element={<Navigate to='/login' />} />
                <Route path="/assessments/:assessmentId/:seoName" element={<Navigate to='/login' />} />
                <Route path="/expert/packages" element={<Navigate to='/login' />} />
                <Route path="/expert/users" element={<Navigate to='/login' />} />
                <Route path="/support" element={<Navigate to='/login' />} />
                <Route path="/support/view/:id" element={<Navigate to='/login' />} />
                <Route path="/expert/users/assign/:id" element={<Navigate to='/login' />} />
                {/* Old address that carried the client's name; kept so existing links still open. */}
                <Route path="/expert/users/:name/:id" element={<Navigate to='/login' />} />
                <Route path="/expert/users/view/:id" element={<Navigate to='/login' />} />
                <Route path="/expert/users/add" element={<Navigate to='/login' />} />
                <Route path="/expert/users/edit/:id" element={<Navigate to='/login' />} />
                <Route path="/purchase/:id" element={<Navigate to='/login' />} />
                <Route path="/profile" element={<Navigate to='/login' />} />
                <Route path="/editProfile" element={<Navigate to='/login' />} />
                <Route path="/changePassword" element={<Navigate to='/login' />} />
                <Route path="/packages/purchase/:id" element={<Navigate to='/login' />} />
                <Route path="/packages/remove/:id" element={<Navigate to='/login' />} />
                <Route path="/faqs" element={<Navigate to='/login' />} />
                <Route path="/onboarding" element={<Navigate to='/login' />} />
              </> : ""}
            <Route path="*" element={<Navigate to='/login' />} />
          </Routes>
        </BrowserRouter>
      }
    </div>
  );
}

export default App;
